// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PostAsrFilterConfigRedoBody, BaseResponseVoid } from '../../types';

/**
 * saveReCoverManualLoad
 *
 * @export
 * @tags asr-filter-config-controller
 * @link [POST] /asr-filter-config/redo
 */
export function postAsrFilterConfigRedo(
    data: PostAsrFilterConfigRedoBody
): Promise<BaseResponseVoid>;
export function postAsrFilterConfigRedo(
    data: PostAsrFilterConfigRedoBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postAsrFilterConfigRedo(
    data: PostAsrFilterConfigRedoBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostAsrFilterConfigRedoBody, never, never>('/asr-filter-config/redo', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postAsrFilterConfigRedo',
    });
}

export const meta = [
    { tags: ['asr-filter-config-controller'], path: '/asr-filter-config/redo', method: 'post' },
];
